<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <!-- 主题内容 -->
    <div class="b-center-container">
      <!-- 富文本 -->
      <div class="b-container">
        <div class="b-center-main">
          <div class="b-richtext">
            <p v-html="richText"></p>
          </div>
        </div>
      </div>
    </div>
    <v-contact></v-contact>
      <!--
      <v-footer></v-footer>
      <v-copy></v-copy>
      -->
  </div>
</template>
<script>
/* eslint-disable */
import Header from "@/components/header/en/";
import Nav from "@/components/nav/en/";
import Breadcrumb from "@/components/breadcrumb/en/"
import Contact from "@/components/contact/en/";
export default {
  data () {
    return {
      richText: '',
    };
  },
  mounted () {
    this.richText = '<p style="text-align: left; "><span style="font-size: 22px; border-bottom: solid 3px #033d80;">Translational Medicine Research Program</span></p>'
      + '<div style="margin-left : 40px; margin-top:50px; margin-bottom: 0px">'

      + '<p style="margin-bottom : 30px"><span style="font-size: 16px;">TM Research Program consists of Research Fund and Visiting Scholar Program, which aim to pushing forward the interdisciplinary research in translational medicine, and promoting academic exchanges, scientific research collaboration and talent training, increasing the depth and broadness of openness and sharing of NFTM.</span></p>'

      +'<p style="margin-top : 15px; margin-bottom : 40px; text-align: center"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/zzyj1_en.png" style="width: 960px; margin-right: 16px; border="0" vspace="0" alt=""></p>'

      + '<div style="margin-left : 0px; margin-top: 10px; margin-bottom: 20px"><div style="font-size: 20px;"><b style="color: #033d80; "> | </b> Research Fund</span></p>'
      + '<p style="margin-bottom : 20px"><span style="font-size: 16px;">Research Fund is open for application for both domestic and foreign scientific researchers and institutions in related fields.</span></p>'
      + '<p style="margin-bottom : 20px"><span style="font-size: 16px;">▶ Focus on the leading translational medicine research on diseases like cancer, cardiovascular and cerebrovascular diseases and metabolic diseases, etc. </span></p>'
      + '<p style="margin-bottom : 20px"><span style="font-size: 16px;">▶ Support studies on the pathogenesis and incidence pattern of those diseases, in order to explore and establish theories, models, early diagnosis, prevention methods and individualized treatment of related diseases. </span></p>'
      + '<p style="margin-bottom : 20px"><span style="font-size: 16px;">▶ Consist of two categories, key projects and general projects. </span></p>'

      + '<div style="margin-left : 0px; margin-top: 60px;margin-bottom: 20px"><div style="font-size: 20px;"><b style="color: #033d80; "> | </b> Visiting Scholars </span></p>'

    + '<p style="margin-top : 10px; margin-bottom : 20px"><span style="font-size: 16px;">Visiting Scholars Program encourages outstanding scholars and researchers in translational medicine related fields at home and abroad to make full use of the facility service. </span></p>'
    + '<p style="margin-bottom : 10px"><span style="font-size: 16px;">Visiting scholars work as part of a research team and are in charge of formulating strategic, forward-looking research goals, planning and implementations.</span></p>'

    + '<p style="margin-top : 30px; margin-bottom : 20px"><span style="margin-left: 0px; font-size: 16px; font-weight: bold; border-bottom: solid 3px #033d80;">Contact</span></p>'
    + '<p style="margin-bottom : 10px"><span style="margin-left: 0px; font-size: 16px;">Chen Xin</span></p>'
     + '<p style="margin-bottom : 10px"><span style="margin-left: 0px; font-size: 16px;">Email: chen.xin@sjtu.edu.cn</span></p>'
    + '<p style="margin-bottom : 10px"><span style="margin-left: 0px; font-size: 16px;">Address: C4, Translational Medicine Building, Shanghai Jiao Tong University, 800 Dongchuan Road, Minhang District, Shanghai, P.R. China</span></p>'

  },
  components: {
    "v-header": Header,
    "v-nav": Nav,
    "v-breadcrumb": Breadcrumb,
    "v-contact": Contact,
  }
};
</script>
<style lang="scss">
  @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
	    //padding: 22px 0;
	    background: url(../../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
    }
  }
.b-richtext {
  text-align:left;
  b,
  strong {
    font-weight: 700;
  }
  p {
    margin: 0 0 10px;
    line-height: 24px;
  }
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/pages/event2/en/index.vue